import{jsx as i,jsxs as c}from"react/jsx-runtime";import{useState as y}from"react";import n from"styled-components";import{Collapse as b}from"react-collapse";import{useNameAndId as u}from"../../hooks/useNameAndId.js";import $ from"../ToggleArrow/index.js";import{BodyLink as k,BodyText as v}from"../../typography/BodyText/index.js";import"../../shared/helpers.js";import"../../icons/components/ShowMoreIcon.js";import"../../shared/media-queries.js";const T=n.div`
  display: flex;
  flex-direction: column;
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
`,I=n.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`,N=n.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  padding: 1rem 0;
`,j=n.li`
  border-top: ${({theme:o})=>`1px solid ${o.colors.grayscaleToned.light2}`};

  &:last-child {
    border-bottom: ${({theme:o})=>`1px solid ${o.colors.grayscaleToned.light2}`};
  }
`,w=n.div`
  padding-bottom: 1rem;

  & > :first-child,
  & > * :first-child {
    margin-top: 0;
    padding-top: 0;
  }
  & > :last-child,
  & > * :last-child {
    margin-bottom: 0;
    padding-bottom: 0rem;
  }
`,m=({items:o,...p})=>{const[h,f]=y({}),{id:l}=u("accordion"),d=e=>{f(t=>({...t,[e]:!t[e]}))},g=e=>()=>{d(e)},x=e=>t=>{(t.key==="Enter"||t.key===" ")&&(t.preventDefault(),d(e))};return i(T,{...p,children:i(I,{className:"accordionList",children:o.map((e,t)=>{const r=!!h[t],a=`${l}-${t}-header`,s=`${l}-${t}-content`;return c(j,{isOpen:r,className:"accordionItem",children:[c(N,{id:a,onClick:g(t),onKeyDown:x(t),className:"accordionItemTitle",role:"button",tabIndex:0,"aria-expanded":r,"aria-controls":s,children:[i(k,{as:"span",children:e.title}),i($,{isExpanded:r})]}),i(b,{isOpened:r,children:i(w,{id:s,"aria-labelledby":a,role:"region",...r?null:{inert:""},children:typeof e.text=="string"?i(v,{children:e.text}):e.text})},t)]},e.title)})})})};export{m as Accordion,m as default};
